import { Injectable, WritableSignal, signal } from '@angular/core';
import {
    DataManagementControllerService,
    DataTableDto,
    DataTableSimpleDto,
    Field,
} from 'app/data-api';
import { Observable, map, switchMap, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TableService {
    tables: WritableSignal<DataTableSimpleDto[]> = signal([]);
    selectedTable: WritableSignal<DataTableSimpleDto> = signal(null);
    fields: WritableSignal<Field[]> = signal([]);
    selectedFields: WritableSignal<Field[]> = signal([]);

    constructor(private service: DataManagementControllerService) {}

    getTableByName(
        tableName: string,
        system: string,
        organisation: string
    ): Observable<DataTableDto> {
        return this.service.getTable(tableName, organisation, system).pipe(
            tap(table => {
                this.fields.set(table.fields);
            })
        );
    }

    getTables(): Observable<DataTableSimpleDto[]> {
        return this.service.getTableList().pipe(
            tap(tables => {
                this.tables.set(tables);
            })
        );
    }

    createTable(table: DataTableDto): Observable<DataTableSimpleDto> {
        return this.service.addNewTable(table).pipe(
            switchMap(table => {
                return this.getTables().pipe(
                    map(() => {
                        return table;
                    })
                );
            })
        );
    }

    updateTable(tableId: string, table: DataTableDto): Observable<DataTableSimpleDto> {
        return this.service.updateTable(tableId, table).pipe(
            switchMap(table => {
                return this.getTables().pipe(
                    map(() => {
                        return table;
                    })
                );
            })
        );
    }

    deleteTable(tableName: string, system: string): Observable<DataTableSimpleDto> {
        return this.service.deleteTable(tableName, system).pipe(
            switchMap(table => {
                return this.getTables().pipe(
                    map(() => {
                        return table;
                    })
                );
            })
        );
    }
}
